<template>
  <SelectTableDialog
    :title="this.$t('supplierDeliveryOrder.creatDialog.title.create')"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :API="listOrderAPI"
    :extraData="{
      contractCategory: 'purchase',
      contractStatus: 'ZT03',
      deliveryFlag: '1', //限制类型
      deliverableQuantityStart: 0, // 测试 后端叫加上这个参数
      departmentCode: userInfo.departmentCode,
      companyCode: userInfo.companyCode,
    }"
    propCode="contractNo"
    width="80%"
    @close="close"
    @dblclickEvent="dblclickEvent"
    @confirm="confirm"
    @changeQuery="changeQuery"
  ></SelectTableDialog>
</template>

<script>
  /**
   * 外部按钮操作打开：(列表头部的按钮) 使用defaultVisible与 @close 监听弹窗开关
   * 内部按钮打开：插槽按钮，无需自行监听
   * 弹窗确认监听 @confirm
   * <SelectTableDialog>
   *  <button>按钮打开弹窗</button>
   * </SelectTableDialog>
   */
  import API from '@/api/wareHouse/supplierDeliveryOrder.js';
  import SelectTableDialog from '@/components/SelectTableDialog';
  // import COMPANY_API from '@/api/masterData/company';
  import BASEAPI from '@/api/dataBase.js';
  import { mapState } from 'vuex';
  export default {
    props: {},
    components: {
      SelectTableDialog,
    },
    data() {
      return {
        isMultiple: false,
        listOrderAPI: '', // 物流入库接口：暂无
        defaultVisible: false,

        departmentList: [],
        query: {
          contractBusinessDepartment: null,
        },
      };
    },
    mounted() {
      this.listOrderAPI = API.LIST_DETAIL;
      this.getDepartment(); //获取部门
    },

    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        // const departmentUrl = this.companyCode
        //   ? `${COMPANY_API.GET_COMPANY_DETAIL_API}/${this.companyCode}`
        //   : '';
        return [
          {
            type: 'input',
            prop: 'contractNo',
            name: this.$t('supplierDeliveryOrder.creatDialog.search.contractNo'),
          },
          {
            type: 'input',
            prop: 'externalContractNo',
            name: this.$t('supplierDeliveryOrder.creatDialog.search.externalContractNo'),
          },
          {
            prop: 'supplierNo', // 供应商
            name: this.$t('supplierDeliveryOrder.creatDialog.search.supplierNo'),
            type: 'searchTableSpec',
            searchType: 'supplier',
            isMultiple: true,
            getSearchCode: 'partnerCode',
            extraData: {
              departmentCode: this.query.contractBusinessDepartment, //部门
              companyCode: this.companyCode, //公司
            },
          },
          // prd 上无意向单号
          // {
          //   type: 'input',
          //   prop: 'intentionNo',
          //   name: this.$t('supplierDeliveryOrder.creatDialog.search.intentionNo'),
          // },
          {
            prop: 'productNo',
            name: this.$t('supplierDeliveryOrder.creatDialog.search.productNo'),
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            isMultiple: true,
            getSearchCode: 'productDetailCode', // 搜索时获取商品列表里面的哪个值作为查询条件
          },
          {
            prop: 'contractSalesmanNo', // 业务员
            name: this.$t('supplierDeliveryOrder.creatDialog.search.contractSalesmanNo'),
            type: 'searchTableSpec',
            searchType: 'personnel',
            isMultiple: true,
            getSearchCode: 'id',
          },
          {
            type: 'select',
            prop: 'contractBusinessDepartment',
            name: this.$t('supplierDeliveryOrder.creatDialog.search.contractBusinessDepartment'),
            clearable: true,
            options: this.departmentList,
          },
          // {//不看剩余为零
          //   prop: "remaindThanZero",
          //   name: this.$t("supplierDeliveryOrder.creatDialog.search.remaindThanZero"),
          //   type: "checkbox",
          //   falseLable: 0,
          //   trueLable: 1,
          //   isChecked: true,
          // },
        ];
      },
      columnList() {
        return [
          {
            prop: 'contractNo',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.contractNo'),
            width: 120,
            fixed: 'left',
          },
          {
            prop: 'externalContractNo',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.externalContractNo'),
            width: 120,
          },
          // fixbug 399
          // {
          //   prop: 'intentionNo',
          //   label: this.$t('supplierDeliveryOrder.creatDialog.table.intentionNo'),
          //   width: 120,
          // },
          {
            prop: 'supplierName',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.supplierName'),
            width: 120,
          },
          {
            prop: 'storageName',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.storageName'),
          },
          // fixbug 399
          // {
          //   prop: 'deliverTypeName',
          //   label: this.$t('supplierDeliveryOrder.creatDialog.table.deliverTypeName'),
          // },
          {
            prop: 'productDesc',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.productDesc'),
            width: 120,
          },
          {
            prop: 'unitName',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.unit'),
            width: 120,
          },
          {
            prop: 'productQuantity',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.productQuantity'),
            width: 120,
            // format: 'formatQuality',
          },
          {
            prop: 'deliverableQuantity',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.deliverableQuantity'),
            width: 120,
            // format: 'formatQuality',
          },
          {
            prop: 'contractSalesmanName',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.contractSalesmanName'),
            width: 120,
          },
          {
            prop: 'contractBusinessDepartmentName',
            label: this.$t(
              'supplierDeliveryOrder.creatDialog.table.contractBusinessDepartmentName'
            ),
            width: 120,
          },
          {
            prop: 'companyName',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.companyName'),
            width: 120,
          },
        ];
      },
    },
    methods: {
      changeQuery(obj) {
        this.query.contractBusinessDepartment = obj.contractBusinessDepartment;
      },
      //获取部门
      async getDepartment() {
        const selectStatus = await this.$axios.post(
          BASEAPI.LIST_DEPARTMENT_API + `/${this.userInfo.companyCode}`
        );
        this.departmentList = selectStatus.data.data;
      },
      //双击选择
      dblclickEvent(selections) {
        this.getData(selections.row);
      },
      // 弹窗确认
      confirm(selections) {
        console.log(selections, 'selections');
        let contractDetailNoList = '';
        if (selections.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('supplierDeliveryOrder.msg.purchaseContractTips'),
            type: 'error',
          });
          return;
        }
        let isSameContract = true; //是否是同一个合同或者意向单
        let isStoragedeliver = true; //选中的项目仓库和交货方式不一致
        let isZero = false; // 发货量是否为0
        selections.forEach((item) => {
          //是否是同一个合同或者意向单
          if (item.contractNo != selections[0].contractNo) {
            isSameContract = false;
          }
          if (item.contractDetailCategory == 'HT04') {
            //选中的项目仓库和交货方式不一致
            if (
              item.storageName != selections[0].storageName ||
              item.deliverType != selections[0].deliverType
            ) {
              isStoragedeliver = false;
            }
          }
          if (item.deliverableQuantity === 0) {
            isZero = true;
          } else {
            isZero = false;
          }
        });
        if (!isSameContract) {
          //不是同一个合同或者意向单
          this.$message({
            showClose: true,
            message: this.$t('supplierDeliveryOrder.msg.selectGoods'),
            type: 'error',
          });
          return;
        }
        if (!isStoragedeliver) {
          //选中的项目仓库和交货方式不一致
          this.$message({
            showClose: true,
            message: this.$t('supplierDeliveryOrder.msg.selectstorageDeliver'),
            type: 'error',
          });
          return;
        }
        if (isZero) {
          return this.$message({
            showClose: true,
            message: '所选合同所有商品行可发货指令数量为0不可再创建发货指令',
            type: 'error',
          });
        }
        if (isSameContract && isStoragedeliver) {
          selections.map((item) => {
            // contractDetailNoList.push(item.contractDetailNo);
            contractDetailNoList += item.contractDetailNo + ',';
          });
          contractDetailNoList = contractDetailNoList.substring(
            0,
            contractDetailNoList.lastIndexOf(',')
          );
          this.getData(selections[0], contractDetailNoList);
        }
        this.loading.startLoading();
      },
      getData(selections, contractDetailNoList) {
        let query = {};
        // if(selections.contractDetailCategory=='HT04'){
        //   query={
        //     contractNo: selections.contractNo,
        //     contractDetailNoList:contractDetailNoList,
        //   }
        // }else{
        //   query={
        //     contractNo: selections.contractNo,
        //   }
        // }
        query = {
          contractNo: selections.contractNo,
          contractDetailNoList: contractDetailNoList,
          businessChangeUnitPrice: selections.businessChangeUnitPrice, // 合同变动单价
          businessContractUnitPrice: selections.businessContractUnitPrice, // 合同单价
          financeContractTaxAmount: selections.businessContractPricePureAmount || 0.9, // 净值
          financeContractPureAmount: selections.businessContractPriceTaxAmount || 0.99, // 税额
          businessContractTotalAmount: selections.businessContractTotalAmount, // 合同总价
          productQuantity: selections.productQuantity, // 采购数量
          // taxRate: selections.taxRate, // 增值税
        };
        this.$axios
          .post(API.CHECK_SHIPPING_API, {
            contractNo: selections.contractNo,
            contractDetailCategory: selections.contractDetailCategory,
          })
          .then((res) => {
            this.loading.endLoading();
            if (0 == res.data.code) {
              // 进入销售提单创建
              let path = {
                path: '/wareHouse/addSupplierDelivery',
                name: 'addSupplierDelivery',
                meta: {
                  keepAlive: true,
                  title: '创建供应商发货指令',
                },
                query: query,
              };
              this.defaultVisible = false;
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
    },
  };
</script>
